import Vue from 'vue'

const state = {
  deliveries: {}
}

const mutations = {
  SET_DELIVERIES (state, deliveries) {
    state.deliveries = deliveries
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('deliveries')
      .then(response => {
        commit('SET_DELIVERIES', response.data)
      })
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
